import { render, staticRenderFns } from "./configureClientModelLineProduct.vue?vue&type=template&id=19f27d95"
import script from "./configureClientModelLineProduct.vue?vue&type=script&lang=js"
export * from "./configureClientModelLineProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports